/* ElectionType client data model
 *
 * Angular Module: trackerbase-app.models.election-type
 * Injected Factory: ElectionType
 */

class ElectionType {
    constructor(electionTypeId, electionTypeName) {
        if (Number.isInteger(electionTypeId)) {
            this.electionTypeId = electionTypeId;
        }
        else {
            throw new TypeError("Missing or invalid election type id.");
        }

        if ((angular.isDefined(electionTypeName)) &&
            (angular.isString(electionTypeName)) &&
            (electionTypeName.length > 0)) {

            this.electionTypeName = electionTypeName;
        }
        else {
            throw new TypeError("Missing or invalid election type name.");
        }
    }

    toString() {
        return `${this.electionTypeName} (${this.electionTypeId})`;
    }

    valueOf() {
        return this.electionTypeId;
    }

    static Copy(srcElectionType) {
        return new ElectionType(
            srcElectionType.electionTypeId,
            srcElectionType.electionTypeName
        );
    }

    static FromServerElectionType(serverElectionType) {
        return new ElectionType(
            serverElectionType.ElectionTypeId,
            serverElectionType.ElectionTypeName
        );
    }


}

export default ElectionType;


//////////////////
// WEBPACK FOOTER
// ./src/models/ElectionType.js
// module id = cll5
// module chunks = 1